import React from 'react';
import PropTypes from 'prop-types';

import MuiTextField from '@material-ui/core/TextField';

import { useTextFieldStyles } from './styles';

const WdTextField = ({ maxLength, borderBottomColor, errors, fontSize, color, ...rest }) => {
	const textFiledClasses = useTextFieldStyles(errors);

	return (
		<MuiTextField
			size="small"
			inputProps={{
				maxLength: maxLength,
				borderBottomColor: borderBottomColor
			}}
			classes={textFiledClasses}
			{...rest}
		/>
	);
};

WdTextField.propTypes = {
	maxLength: PropTypes.number
};

export default WdTextField;
